
// const user = JSON.parse(localStorage.getItem("user"));
// var perusahaanId;
// if (user){
//  perusahaanId = user.perusahaan.id;
// }

export const headersAnggaran = [
  { label: "Month", key: "month" },
  { label: "Year", key: "year" },
  { label: "Pendapatan", key: "pendapatan" },
  { label: "Beban Pendapatan", key: "bebanPendapatan" },
  { label: "Beban Penjualan", key: "bebanPenjualan" },
  { label: "Beban Administrasi", key: "bebanAdministrasi" },
  { label: "Beban Operasional Lainnya", key: "bebanOperasionalLainnya" },
  { label: "Pendapatan Lain", key: "pendapatanLain" },
  { label: "Beban Lain", key: "bebanLain" },
  { label: "Beban Penyusutan", key: "bebanPenyusutan" },
  { label: "Beban Bunga", key: "bebanBunga" },
  { label: "Beban Pajak", key: "bebanPajak" },
];

export const headersLaba = [
  { label: "Month", key: "month" },
  { label: "Year", key: "year" },
  // { label: "Perusahaan", key: "perusahaan" },
  { label: "Pendapatan", key: "pendapatan" },
  { label: "bebanMaterial", key: "bebanMaterial" },
  { label: "bebanPegawai", key: "bebanPegawai" },
  { label: "factoryOverhead", key: "factoryOverhead" },
  { label: "bebanCsr", key: "bebanCsr" },
  { label: "bebanPenyusutan", key: "bebanPenyusutan" },
  { label: "pbpAktivaTetap", key: "pbpAktivaTetap" },
  { label: "pbpAktivaNonproduktif", key: "pbpAktivaNonproduktif" },
  { label: "pbpAktivaLainnya", key: "pbpAktivaLainnya" },
  { label: "pbpSahamPenyertaan", key: "pbpSahamPenyertaan" },
  { label: "pendapatanBunga", key: "pendapatanBunga" },
  { label: "bebanBunga", key: "bebanBunga" },
  { label: "pendapatanLain", key: "pendapatanLain" },
  { label: "bebanLain", key: "bebanLain" },
  { label: "pajakKini", key: "pajakKini" },
  { label: "pajakTangguhan", key: "pajakTangguhan" },
  { label: "pbKomperhensifLain", key: "pbKomperhensifLain" },

  { label: "rkapPendapatan", key: "rkapPendapatan" },
  { label: "rkapBebanMaterial", key: "rkapBebanMaterial" },
  { label: "rkapBebanPegawai", key: "rkapBebanPegawai" },
  { label: "rkapFactoryOverhead", key: "rkapFactoryOverhead" },
  { label: "rkapBebanCsr", key: "rkapBebanCsr" },
  { label: "rkapBebanPenyusutan", key: "rkapBebanPenyusutan" },
  { label: "rkapPbpAktivaTetap", key: "rkapPbpAktivaTetap" },
  { label: "rkapPbpAktivaNonproduktif", key: "rkapPbpAktivaNonproduktif" },
  { label: "rkapPbpAktivaLainnya", key: "rkapPbpAktivaLainnya" },
  { label: "rkapPbpSahamPenyertaan", key: "rkapPbpSahamPenyertaan" },
  { label: "rkapPendapatanBunga", key: "rkapPendapatanBunga" },
  { label: "rkapBebanBunga", key: "rkapBebanBunga" },
  { label: "rkapPendapatanLain", key: "rkapPendapatanLain" },
  { label: "rkapBebanLain", key: "rkapBebanLain" },
  { label: "rkapPajakKini", key: "rkapPajakKini" },
  { label: "rkapPajakTangguhan", key: "rkapPajakTangguhan" },
  { label: "rkapPbKomperhensifLain", key: "rkapPbKomperhensifLain" },
];

export const headersArus = [
  { label: "Month", key: "month" },
  { label: "Year", key: "year" },
  // { label: "Perusahaan", key: "perusahaan" },
  { label: "arusAktivitasOperasi", key: "arusAktivitasOperasi" },
  { label: "arusAktivitasInvestasi", key: "arusAktivitasInvestasi" },
  { label: "arusAktivitasPendanaan", key: "arusAktivitasPendanaan" },
  { label: "Kas Awal", key: "kasAwal" },
  { label: "rkapArusAktivitasOperasi", key: "rkapArusAktivitasOperasi" },
  { label: "rkapArusAktivitasInvestasi", key: "rkapArusAktivitasInvestasi" },
  { label: "rkapArusAktivitasPendanaan", key: "rkapArusAktivitasPendanaan" },
  { label: "rkapKasAwal", key: "rkapKasAwal" },
];

// export const dataPerusahaan = [
//   {perusahaan: `${perusahaanId}`},
// ];


export const headersNeraca = [
  { label: "Month", key: "month" },
  { label: "Year", key: "year" },
  // { label: "Perusahaan", key: "perusahaan" },
  // aset lancar
  { label: "Kas", key: "kas" },
  { label: "investasiJangkaPendek", key: "investasiJangkaPendek" },
  { label: "puPihakBerelasi", key: "puPihakBerelasi" },
  { label: "puPihakKetiga", key: "puPihakKetiga" },
  { label: "plPihakBerelasi", key: "plPihakBerelasi" },
  { label: "plPihakKetiga", key: "plPihakKetiga" },
  { label: "persediaan", key: "persediaan" },
  { label: "uangMukaOperasional", key: "uangMukaOperasional" },
  { label: "uangMukaProyek", key: "uangMukaProyek" },
  { label: "pendapatanHarusDiterima", key: "pendapatanHarusDiterima" },
  { label: "biayaDibayarDimuka", key: "biayaDibayarDimuka" },
  { label: "pajakDibayarDimuka", key: "pajakDibayarDimuka" },
  { label: "asetJaminan", key: "asetJaminan" },
  { label: "pjpJatuhTempo", key: "pjpJatuhTempo" },
  { label: "asetLancarLainnya", key: "asetLancarLainnya" },
  // aset tidak lancar
  { label: "asetTetapBersih", key: "asetTetapBersih" },
  { label: "asetTakBerwujud", key: "asetTakBerwujud" },
  { label: "asetHakGuna", key: "asetHakGuna" },
  { label: "asetTanahPengembangan", key: "asetTanahPengembangan" },
  { label: "asetDalamPenyelesaian", key: "asetDalamPenyelesaian" },
  { label: "pjpPihakBerelasi", key: "pjpPihakBerelasi" },
  { label: "pjpPihakKetiga", key: "pjpPihakKetiga" },
  { label: "umpAsetTetap", key: "umpAsetTetap" },
  { label: "investasiJangkaPanjang", key: "investasiJangkaPanjang" },
  { label: "investasiEntitasAsosiasi", key: "investasiEntitasAsosiasi" },
  { label: "persediaanRealEstate", key: "persediaanRealEstate" },
  { label: "propertiInvestasiBersih", key: "propertiInvestasiBersih" },
  { label: "asetPajakTangguhan", key: "asetPajakTangguhan" },
  { label: "taksiranRestitusiPajak", key: "taksiranRestitusiPajak" },
  { label: "asetPengampunanPajak", key: "asetPengampunanPajak" },
  { label: "cadanganImbalanKerja", key: "cadanganImbalanKerja" },
  { label: "asetTidaklancarLainnya", key: "asetTidaklancarLainnya" },
  // Liabilitas Jangka Pendek
  { label: "utangBankPendek", key: "utangBankPendek" },
  { label: "uuPihakBerelasi", key: "uuPihakBerelasi" },
  { label: "uuPihakKetiga", key: "uuPihakKetiga" },
  { label: "ulPihakBerelasi", key: "ulPihakBerelasi" },
  { label: "ulPihakKetiga", key: "ulPihakKetiga" },
  { label: "utangRetensiPendek", key: "utangRetensiPendek" },
  { label: "utangPajak", key: "utangPajak" },
  { label: "pddPendek", key: "pddPendek" },
  { label: "utangDeviden", key: "utangDeviden" },
  { label: "utangSewa", key: "utangSewa" },
  { label: "biayaDibayarPendek", key: "biayaDibayarPendek" },
  { label: "bubJatuhTempo", key: "bubJatuhTempo" },
  { label: "liabilitasPendekLainnya", key: "liabilitasPendekLainnya" },
    // Liabilitas Jangka Panjan
  { label: "utangBankPanjang", key: "utangBankPanjang" },
  { label: "ulpPihakBerelasi", key: "ulpPihakBerelasi" },
  { label: "ulpPihakKetiga", key: "ulpPihakKetiga" },
  { label: "pddPanjang", key: "pddPanjang" },
  { label: "pajakTangguhanNeraca", key: "pajakTangguhanNeraca" },
  { label: "utangRetensiPanjang", key: "utangRetensiPanjang" },
  { label: "biayaDibayarPanjang", key: "biayaDibayarPanjang" },
  { label: "utangPembiayaanPanjang", key: "utangPembiayaanPanjang" },
  { label: "liabilitasImbalanKerja", key: "liabilitasImbalanKerja" },
  { label: "titipanPelepasanAset", key: "titipanPelepasanAset" },
  { label: "utangLainPenyelesaian", key: "utangLainPenyelesaian" },
  { label: "liabilitasPanjangLainnya", key: "liabilitasPanjangLainnya" },
    // Ekuitas
  { label: "modalSaham", key: "modalSaham" },
  { label: "tambahanModalDisetor", key: "tambahanModalDisetor" },
  { label: "cadanganModal", key: "cadanganModal" },
  { label: "telahDitentukanPenggunaan", key: "telahDitentukanPenggunaan" },
  { label: "belumDitentukanPenggunaan", key: "belumDitentukanPenggunaan" },
  { label: "penghasilanKomperhensifLain", key: "penghasilanKomperhensifLain" },
  { label: "deviden", key: "deviden" },
  { label: "komponenEkuitasLain", key: "komponenEkuitasLain" },
  { label: "kepentinganNonPengendali", key: "kepentinganNonPengendali" },

// RKAP
  // aset lancar
  { label: "rkapKas", key: "rkapKas" },
  { label: "rkapInvestasiJangkaPendek", key: "rkapInvestasiJangkaPendek" },
  { label: "rkapPuPihakBerelasi", key: "rkapPuPihakBerelasi" },
  { label: "rkapPuPihakKetiga", key: "rkapPuPihakKetiga" },
  { label: "rkapPlPihakBerelasi", key: "rkapPlPihakBerelasi" },
  { label: "rkapPlPihakKetiga", key: "rkapPlPihakKetiga" },
  { label: "rkapPersediaan", key: "rkapPersediaan" },
  { label: "rkapUangMukaOperasional", key: "rkapUangMukaOperasional" },
  { label: "rkapUangMukaProyek", key: "rkapUangMukaProyek" },
  { label: "rkapPendapatanHarusDiterima", key: "rkapPendapatanHarusDiterima" },
  { label: "rkapBiayaDibayarDimuka", key: "rkapBiayaDibayarDimuka" },
  { label: "rkapPajakDibayarDimuka", key: "rkapPajakDibayarDimuka" },
  { label: "rkapAsetJaminan", key: "rkapAsetJaminan" },
  { label: "rkapPjpJatuhTempo", key: "rkapPjpJatuhTempo" },
  { label: "rkapAsetLancarLainnya", key: "rkapAsetLancarLainnya" },
  // aset tidak lancar
  { label: "rkapAsetTetapBersih", key: "rkapAsetTetapBersih" },
  { label: "rkapAsetTakBerwujud", key: "rkapAsetTakBerwujud" },
  { label: "rkapAsetHakGuna", key: "rkapAsetHakGuna" },
  { label: "rkapAsetTanahPengembangan", key: "rkapAsetTanahPengembangan" },
  { label: "rkapAsetDalamPenyelesaian", key: "rkapAsetDalamPenyelesaian" },
  { label: "rkapPjpPihakBerelasi", key: "rkapPjpPihakBerelasi" },
  { label: "rkapPjpPihakKetiga", key: "rkapPjpPihakKetiga" },
  { label: "rkapUmpAsetTetap", key: "rkapUmpAsetTetap" },
  { label: "rkapInvestasiJangkaPanjang", key: "rkapInvestasiJangkaPanjang" },
  { label: "rkapInvestasiEntitasAsosiasi", key: "rkapInvestasiEntitasAsosiasi" },
  { label: "rkapPersediaanRealEstate", key: "rkapPersediaanRealEstate" },
  { label: "rkapPropertiInvestasiBersih", key: "rkapPropertiInvestasiBersih" },
  { label: "rkapAsetPajakTangguhan", key: "rkapAsetPajakTangguhan" },
  { label: "rkapTaksiranRestitusiPajak", key: "rkapTaksiranRestitusiPajak" },
  { label: "rkapAsetPengampunanPajak", key: "rkapAsetPengampunanPajak" },
  { label: "rkapCadanganImbalanKerja", key: "rkapCadanganImbalanKerja" },
  { label: "rkapAsetTidaklancarLainnya", key: "rkapAsetTidaklancarLainnya" },
  // Liabilitas Jangka Pendek
  { label: "rkapUtangBankPendek", key: "rkapUtangBankPendek" },
  { label: "rkapUuPihakBerelasi", key: "rkapUuPihakBerelasi" },
  { label: "rkapUuPihakKetiga", key: "rkapUuPihakKetiga" },
  { label: "rkapUlPihakBerelasi", key: "rkapUlPihakBerelasi" },
  { label: "rkapUlPihakKetiga", key: "rkapUlPihakKetiga" },
  { label: "rkapUtangRetensiPendek", key: "rkapUtangRetensiPendek" },
  { label: "rkapUtangPajak", key: "rkapUtangPajak" },
  { label: "rkapPddPendek", key: "rkapPddPendek" },
  { label: "rkapUtangDeviden", key: "rkapUtangDeviden" },
  { label: "rkapUtangSewa", key: "rkapUtangSewa" },
  { label: "rkapBiayaDibayarPendek", key: "rkapBiayaDibayarPendek" },
  { label: "rkapBubJatuhTempo", key: "rkapBubJatuhTempo" },
  { label: "rkapLiabilitasPendekLainnya", key: "rkapLiabilitasPendekLainnya" },
    // Liabilitas Jangka Panjan
  { label: "rkapUtangBankPanjang", key: "utanrkapUtangBankPanjanggBankPanjang" },
  { label: "rkapUlpPihakBerelasi", key: "rkapUlpPihakBerelasi" },
  { label: "rkapUlpPihakKetiga", key: "rkapUlpPihakKetiga" },
  { label: "rkapPddPanjang", key: "rkapPddPanjang" },
  { label: "rkapPajakTangguhanNeraca", key: "rkapPajakTangguhanNeraca" },
  { label: "rkapUtangRetensiPanjang", key: "rkapUtangRetensiPanjang" },
  { label: "rkapBiayaDibayarPanjang", key: "rkapBiayaDibayarPanjang" },
  { label: "rkapUtangPembiayaanPanjang", key: "rkapUtangPembiayaanPanjang" },
  { label: "rkapLiabilitasImbalanKerja", key: "rkapLiabilitasImbalanKerja" },
  { label: "rkapTitipanPelepasanAset", key: "rkapTitipanPelepasanAset" },
  { label: "rkapUtangLainPenyelesaian", key: "rkapUtangLainPenyelesaian" },
  { label: "rkapLiabilitasPanjangLainnya", key: "rkapLiabilitasPanjangLainnya" },
    // Ekuitas
  { label: "rkapModalSaham", key: "rkapModalSaham" },
  { label: "rkapTambahanModalDisetor", key: "rkapTambahanModalDisetor" },
  { label: "rkapCadanganModal", key: "rkapCadanganModal" },
  { label: "rkapTelahDitentukanPenggunaan", key: "rkapTelahDitentukanPenggunaan" },
  { label: "rkapBelumDitentukanPenggunaan", key: "rkapBelumDitentukanPenggunaan" },
  { label: "rkapPenghasilanKomperhensifLain", key: "rkapPenghasilanKomperhensifLain" },
  { label: "rkapDeviden", key: "rkapDeviden" },
  { label: "rkapKomponenEkuitasLain", key: "rkapKomponenEkuitasLain" },
  { label: "rkapKepentinganNonPengendali", key: "rkapKepentinganNonPengendali" },
,
];

export const headersPegawai = [
  { label: "Nama", key: "nama" },
  { label: "NIP", key: "nik" },
  { label: "Jenis Kelamin", key: "jenisKelamin" },
  { label: "Telepon", key: "telepon" },
  { label: "Email", key: "email" },
  { label: "Tempat Lahir", key: "tempatLahir" },
  { label: "Tanggal Lahir", key: "tanggalLahir" },
  { label: "Alamat", key: "alamat" },
  { label: "Kelurahan", key: "kelurahanId" },
  { label: "SMP", key: "smp" },
  { label: "SMA", key: "sma" },
  { label: "S1", key: "s1" },
  { label: "S2", key: "s2" },
  { label: "S3", key: "s3" },
  { label: "Mulai Kerja", key: "mulaiKerja" },
  { label: "Posisi", key: "posisi" },
  { label: "Tingkat", key: "tingkat" },
  { label: "Divisi", key: "divisi" },
  { label: "Departemen", key: "departemen" },
  { label: "Performa", key: "performa" },
  { label: "Bakat", key: "bakat" },
  { label: "Pengembangan", key: "pengembangan" },
];
